// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddTicketModal_modal__UrdUk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  animation: AddTicketModal_fadeIn__PoGNS 0.05s ease-out forwards;
}

.AddTicketModal_modalContent__RseiN {
  background-color: #181a1b;
  color: white;
  padding: 20px;
  border-radius: 8px;
  width: 600px;
  height: 600px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.7);
  font-family: Arial, sans-serif;
  opacity: 0;
  transform: scale(0.9);
  animation: AddTicketModal_modalContentFadeIn__gTEMo 0.1s ease-out 0.025s forwards;
  display: flex;
  flex-direction: column;
}

/* Simple fade in animation */
@keyframes AddTicketModal_fadeIn__PoGNS {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal fade in animation */
@keyframes AddTicketModal_modalFadeIn__ERpuN {
  from {
    background-color: rgba(0, 0, 0, 0);
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
}

/* Modal content zoom and fade in animation */
@keyframes AddTicketModal_modalContentZoom__d353l {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Simple fade out animation */
.AddTicketModal_modal__UrdUk.AddTicketModal_closing__A8Ga2 {
  animation: AddTicketModal_fadeOut__WcvK9 0.15s ease-in forwards;
}

.AddTicketModal_modal__UrdUk.AddTicketModal_closing__A8Ga2 .AddTicketModal_modalContent__RseiN {
  animation: AddTicketModal_modalContentFadeOut__OK3wr 0.15s ease-in forwards;
}

/* Modal content fade in animation */
@keyframes AddTicketModal_modalContentFadeIn__gTEMo {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Modal content fade out animation */
@keyframes AddTicketModal_modalContentFadeOut__OK3wr {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
}

/* Simple fade out animation */
@keyframes AddTicketModal_fadeOut__WcvK9 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes AddTicketModal_modalFadeOut__vWzdU {
  from {
    background-color: rgba(0, 0, 0, 0.5);
  }
  to {
    background-color: rgba(0, 0, 0, 0);
  }
}

@keyframes AddTicketModal_modalContentZoomOut__cPV\\+K {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0.8);
    opacity: 0;
  }
}

/* Logo fade in/out animation for loading */
@keyframes AddTicketModal_fadeInOut__2EMeF {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.8;
    transform: scale(0.95);
  }
}

.AddTicketModal_formGroup__U-vaS {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.AddTicketModal_label__0AAl2 {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.AddTicketModal_input__SfpHK {
  width: 100%;
  padding: 8px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  background-color: #23272a;
  color: white;
  box-sizing: border-box;
  accent-color: #6c757d;
}

.AddTicketModal_select__OiWL1 {
  width: 100%;
  padding: 8px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  background-color: #23272a;
  color: white;
  box-sizing: border-box;
  accent-color: #6c757d;
}

.AddTicketModal_textarea__DYxuR {
  width: 100%;
  padding: 8px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  background-color: #23272a;
  color: white;
  height: 200px;
  resize: none;
  box-sizing: border-box;
  scrollbar-color: #23272a #181a1b;
  scrollbar-width: thin;
}

.AddTicketModal_buttonGroup__5LKrk {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 20px;
}

.AddTicketModal_button__s2a3Z {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.AddTicketModal_primaryButton__RkVvc {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  background-color: #007BFF;
  color: white;
}

.AddTicketModal_primaryButton__RkVvc:hover {
  background-color: #0056b3;
}

.AddTicketModal_secondaryButton__HW4xw {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  background-color: #6c757d;
  color: white;
}

/* Calendar icon and textarea scrollbar styles */
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(50%) sepia(6%) saturate(0%) hue-rotate(180deg) brightness(90%) contrast(90%);
}
input[type="date"]::placeholder {
  color: #6c757d;
}
textarea::-webkit-scrollbar {
  width: 8px;
  background: #181a1b;
}
textarea::-webkit-scrollbar-thumb {
  background: #23272a;
  border-radius: 4px;
}
textarea::-webkit-scrollbar-corner {
  background: #181a1b;
}

.AddTicketModal_darkDatePicker__RqAgk {
  background: #23272a !important;
  color: #fff !important;
  border: 1px solid #444 !important;
}

.AddTicketModal_darkCalendar__c4YaZ {
  background: #23272a !important;
  color: #fff !important;
  border-radius: 8px !important;
  border: 1px solid #444 !important;
}

.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__day--selected__ric-l,
.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__day--keyboard-selected__bq2Ct {
  background: #007BFF !important;
  color: #fff !important;
}

.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__header__3LwC\\+ {
  background: #181a1b !important;
  border-bottom: 1px solid #444 !important;
}

.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__current-month__LJdxs,
.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__day-name__HXha2 {
  color: #fff !important;
}

.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__day__t6o\\+f {
  color: #fff !important;
}

.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__day--disabled__uHYLw {
  color: #666 !important;
}

.AddTicketModal_darkCalendar__c4YaZ .AddTicketModal_react-datepicker__triangle__HgUjb {
  display: none;
}

.AddTicketModal_stepsContainer__tkQ0T {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 10px; /* Increased top/bottom padding for better spacing */
  border: 1px solid #444;
  border-radius: 8px;
  background-color: #1e1e1e;
  box-sizing: border-box;
  height: 100%;
  max-height: 680px; /* Increased height to better utilize the 750px modal height */
  overflow-y: auto; /* Enable vertical scrolling */
}

.AddTicketModal_stepsContainer__tkQ0T h3 {
  margin: 0 0 10px 0; /* Consistent spacing for h3 elements */
}

.AddTicketModal_stepsTableWrapper__FUl5h {
  flex: 1 1;
  overflow-y: auto; /* Make the table scrollable */
}

.AddTicketModal_stepsTable__Qa7WU {
  width: 100%;
  border-collapse: collapse;
  margin-top: 5px;
}

/* Hide column headers */
.AddTicketModal_stepsTable__Qa7WU th {
  display: none;
}

.AddTicketModal_stepsTable__Qa7WU td {
  border: 1px solid #444;
  padding: 8px;
  text-align: left;
  color: white;
}

.AddTicketModal_stepsTable__Qa7WU tr:nth-child(even) {
  background-color: #2b2d30;
}

.AddTicketModal_stepsTable__Qa7WU tr:hover {
  background-color: #3a3d42;
}

.AddTicketModal_deleteButton__qQCqy {
  background: none;
  border: none;
  color: #ff4d4d;
  font-weight: bold;
  cursor: pointer;
}

.AddTicketModal_stepsInput__9emB2 {
  width: 100%; /* Match the width of the table */
  min-height: 34px; /* Ensure a single-line input field */
  padding: 8px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  background-color: #23272a;
  color: white;
  box-sizing: border-box; /* Ensure padding doesn't affect width */
}

/* === Listen-Items (Steps + Todos) mit Hover-Actions === */

.AddTicketModal_itemCount__ULbNG {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  background-color: #2b2d30;
  color: #aaa;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  vertical-align: middle;
}

.AddTicketModal_itemList__erZiL {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.AddTicketModal_itemEmpty__LDG3Q {
  color: #777;
  font-size: 13px;
  font-style: italic;
  margin: 6px 2px;
}

.AddTicketModal_itemRow__9\\+dI1 {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 7px 9px;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  transition: background-color 0.15s ease;
}

/* Hover: nur subtiler Hintergrund-Lift, kein Layout-Shift, keine Icons */
.AddTicketModal_itemRow__9\\+dI1:hover {
  background-color: rgba(255, 255, 255, 0.07);
}

/* Aktive (ausgewaehlte/editierte) Row: deutlichere Hintergrung + Rahmen */
.AddTicketModal_itemRow__9\\+dI1:focus-within {
  background-color: rgba(255, 255, 255, 0.09);
  border-color: rgba(255, 255, 255, 0.22);
}

.AddTicketModal_itemMain__Bqa0W {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.AddTicketModal_itemText__slbFF {
  color: #e8e8e8;
  font-size: 13.5px;
  line-height: 1.4;
  word-break: break-word;
  white-space: pre-wrap;
  cursor: text;
}

.AddTicketModal_itemDate__lHg4J {
  font-size: 10.5px;
  color: #777;
  font-style: italic;
}

.AddTicketModal_itemEditTextarea__Bdxvb {
  width: 100%;
  min-height: 1.4em;
  background-color: #23272a;
  border: 1px solid #4a9eff;
  border-radius: 4px;
  color: #e8e8e8;
  padding: 1px 2px;
  margin: -1px -2px;
  font-size: 13.5px;
  font-family: inherit;
  line-height: 1.4;
  outline: none;
  resize: none;
  overflow: hidden;
  box-sizing: content-box;
  /* lange Texte umbrechen wie der statische Text */
  white-space: pre-wrap;
  word-break: break-word;
}

.AddTicketModal_itemActions__MXxyA {
  display: none;
  align-items: center;
  gap: 1px;
  flex-shrink: 0;
}

/* Icons NUR beim Klick (Edit-Modus = Textarea hat Focus). Beim Hover: keine Icons, kein Layout-Shift. */
.AddTicketModal_itemRow__9\\+dI1:focus-within .AddTicketModal_itemActions__MXxyA {
  display: flex;
}

.AddTicketModal_itemActionBtn__AIGHj {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
  color: #999;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.AddTicketModal_itemActionBtn__AIGHj:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.AddTicketModal_itemActionDanger__1BM8Z:hover {
  color: #ff4d4d;
}

/* Mobile Modal Styles */
@media (max-width: 768px) {
  .AddTicketModal_modal__UrdUk {
    padding: 0 !important;
    align-items: flex-start !important;
  }

  .AddTicketModal_mobileModalContent__qLyfH {
    width: 100vw !important;
    height: 100vh !important;
    background-color: #181a1b !important;
    color: white !important;
    border-radius: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .AddTicketModal_mobileHeader__JjHCG {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 15px 20px !important;
    background-color: rgba(24, 26, 27, 0.95) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    z-index: 10 !important;
  }

  .AddTicketModal_closeButton__wjLIA {
    background: none !important;
    border: none !important;
    color: white !important;
    font-size: 24px !important;
    cursor: pointer !important;
    width: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    transition: all 0.2s !important;
  }

  .AddTicketModal_closeButton__wjLIA:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  .AddTicketModal_mobileTitle__oP9Ue {
    font-size: 18px !important;
    margin: 0 !important;
    text-align: center !important;
    flex: 1 1 !important;
  }

  .AddTicketModal_saveButton__HVADC {
    background-color: #007BFF !important;
    color: white !important;
    border: none !important;
    padding: 8px 16px !important;
    border-radius: 6px !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    transition: all 0.2s !important;
  }

  .AddTicketModal_saveButton__HVADC:hover {
    background-color: #0056b3 !important;
  }

  .AddTicketModal_pageIndicators__w3iuA {
    display: flex !important;
    justify-content: center !important;
    gap: 0 !important;
    padding: 10px 0 !important;
    background-color: rgba(24, 26, 27, 0.95) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  .AddTicketModal_pageIndicator__H2IaO {
    flex: 1 1 !important;
    padding: 12px 0 !important;
    background: none !important;
    border: none !important;
    color: rgba(255, 255, 255, 0.6) !important;
    font-size: 14px !important;
    cursor: pointer !important;
    transition: all 0.3s !important;
    border-bottom: 2px solid transparent !important;
  }

  .AddTicketModal_pageIndicator__H2IaO.AddTicketModal_active__laEJt {
    color: #007BFF !important;
    border-bottom-color: #007BFF !important;
  }

  .AddTicketModal_mobilePages__HmTfm {
    display: flex !important;
    flex: 1 1 !important;
    transition: transform 0.3s ease !important;
    overflow: hidden !important;
  }

  .AddTicketModal_mobilePage__yWZua {
    width: 100vw !important;
    flex-shrink: 0 !important;
    padding: 20px !important;
    overflow-y: auto !important;
    box-sizing: border-box !important;
    min-height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .AddTicketModal_mobileForm__ETa-5 {
    display: flex !important;
    flex-direction: column !important;
    gap: 15px !important;
    flex: 1 1 !important;
    min-height: 100% !important;
  }

  .AddTicketModal_mobileFormGroup__x\\+LWc {
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .AddTicketModal_mobileLabel__MHguU {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: white !important;
  }

  .AddTicketModal_mobileInput__B1WCN, .AddTicketModal_mobileSelect__zuo0E {
    padding: 12px !important;
    border: 1px solid #444 !important;
    border-radius: 6px !important;
    font-size: 16px !important;
    background-color: #23272a !important;
    color: white !important;
    box-sizing: border-box !important;
  }

  .AddTicketModal_mobileTextarea__6OOki {
    padding: 12px !important;
    border: 1px solid #444 !important;
    border-radius: 6px !important;
    font-size: 16px !important;
    background-color: #23272a !important;
    color: white !important;
    min-height: 120px !important;
    resize: vertical !important;
    box-sizing: border-box !important;
  }

  .AddTicketModal_mobileDeleteButton__mXqte {
    background-color: #dc3545 !important;
    color: white !important;
    border: none !important;
    padding: 12px 20px !important;
    border-radius: 6px !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    transition: all 0.2s !important;
    margin-top: 10px !important;
  }

  .AddTicketModal_mobileDeleteButton__mXqte:hover {
    background-color: #c82333 !important;
  }

  .AddTicketModal_mobilePageContent__uxCz\\+ {
    display: flex !important;
    flex-direction: column !important;
    gap: 15px !important;
    flex: 1 1 !important;
    min-height: 100% !important;
  }

  .AddTicketModal_mobilePageTitle__NIxNB {
    font-size: 20px !important;
    font-weight: 600 !important;
    margin: 0 0 10px 0 !important;
    color: white !important;
  }

  .AddTicketModal_mobileList__Epy01 {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;
  }

  .AddTicketModal_mobileListItem__O\\+gVp {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 12px !important;
    background-color: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 6px !important;
    gap: 10px !important;
  }

  .AddTicketModal_mobileListText__rwfox {
    flex: 1 1 !important;
    color: white !important;
    font-size: 14px !important;
  }

  .AddTicketModal_mobileListActions__gfj1Q {
    display: flex !important;
    gap: 8px !important;
  }

  .AddTicketModal_mobileDoneButton__kqQp6 {
    background-color: #28a745 !important;
    color: white !important;
    border: none !important;
    padding: 6px 12px !important;
    border-radius: 4px !important;
    cursor: pointer !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    transition: all 0.2s !important;
  }

  .AddTicketModal_mobileDoneButton__kqQp6:hover {
    background-color: #218838 !important;
  }

  .AddTicketModal_mobileDeleteItemButton__wlq8G {
    background-color: #dc3545 !important;
    color: white !important;
    border: none !important;
    padding: 6px 10px !important;
    border-radius: 4px !important;
    cursor: pointer !important;
    font-size: 12px !important;
    transition: all 0.2s !important;
  }

  .AddTicketModal_mobileDeleteItemButton__wlq8G:hover {
    background-color: #c82333 !important;
  }

  .AddTicketModal_mobileFooter__9QLFo {
    display: flex !important;
    justify-content: center !important;
    padding: 20px !important;
    background-color: rgba(24, 26, 27, 0.95) !important;
    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  .AddTicketModal_mobileSaveButton__IizSX {
    background-color: #007bff !important;
    color: white !important;
    border: none !important;
    padding: 12px 20px !important;
    border-radius: 6px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    width: 100% !important;
    max-width: 300px !important;
  }

  .AddTicketModal_mobileSaveButton__IizSX:hover {
    background-color: #0056b3 !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/AddTicketModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,+DAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,UAAU;EACV,qBAAqB;EACrB,iFAA2D;EAC3D,aAAa;EACb,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,kCAAkC;EACpC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,+DAAyC;AAC3C;;AAEA;EACE,2EAAqD;AACvD;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,2FAA2F;AAC7F;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB,EAAE,oDAAoD;EACxE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB,EAAE,8DAA8D;EACjF,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,iCAAiC;EAC9C,gBAAgB,EAAE,qCAAqC;EACvD,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,sBAAsB,EAAE,wCAAwC;AAClE;;AAEA,2DAA2D;;AAE3D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,yEAAyE;AACzE;EACE,2CAA2C;AAC7C;;AAEA,0EAA0E;AAC1E;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iDAAiD;EACjD,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,wGAAwG;AACxG;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE;IACE,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,oCAAoC;IACpC,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,6BAA6B;IAC7B,mDAAmD;IACnD,4DAA4D;IAC5D,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,6BAA6B;IAC7B,oBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,iBAAiB;IACjB,0BAA0B;IAC1B,mDAAmD;IACnD,4DAA4D;EAC9D;;EAEA;IACE,oBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,0CAA0C;IAC1C,0BAA0B;IAC1B,0BAA0B;IAC1B,+BAA+B;IAC/B,+CAA+C;EACjD;;EAEA;IACE,yBAAyB;IACzB,uCAAuC;EACzC;;EAEA;IACE,wBAAwB;IACxB,oBAAkB;IAClB,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,oBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,6BAA6B;IAC7B,0BAA0B;IAC1B,oCAAoC;IACpC,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,6BAA6B;IAC7B,0BAA0B;IAC1B,oCAAoC;IACpC,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,oBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,wBAAwB;IACxB,sDAAsD;IACtD,qDAAqD;IACrD,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,oBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,wBAAwB;IACxB,mDAAmD;IACnD,yDAAyD;EAC3D;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  opacity: 0;\n  animation: fadeIn 0.05s ease-out forwards;\n}\n\n.modalContent {\n  background-color: #181a1b;\n  color: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 600px;\n  height: 600px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.7);\n  font-family: Arial, sans-serif;\n  opacity: 0;\n  transform: scale(0.9);\n  animation: modalContentFadeIn 0.1s ease-out 0.025s forwards;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Simple fade in animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal fade in animation */\n@keyframes modalFadeIn {\n  from {\n    background-color: rgba(0, 0, 0, 0);\n  }\n  to {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n}\n\n/* Modal content zoom and fade in animation */\n@keyframes modalContentZoom {\n  from {\n    transform: scale(0.7);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Simple fade out animation */\n.modal.closing {\n  animation: fadeOut 0.15s ease-in forwards;\n}\n\n.modal.closing .modalContent {\n  animation: modalContentFadeOut 0.15s ease-in forwards;\n}\n\n/* Modal content fade in animation */\n@keyframes modalContentFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Modal content fade out animation */\n@keyframes modalContentFadeOut {\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n}\n\n/* Simple fade out animation */\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes modalFadeOut {\n  from {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n  to {\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n\n@keyframes modalContentZoomOut {\n  from {\n    transform: scale(1);\n    opacity: 1;\n  }\n  to {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n}\n\n/* Logo fade in/out animation for loading */\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0.8;\n    transform: scale(0.95);\n  }\n}\n\n.formGroup {\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #23272a;\n  color: white;\n  box-sizing: border-box;\n  accent-color: #6c757d;\n}\n\n.select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #23272a;\n  color: white;\n  box-sizing: border-box;\n  accent-color: #6c757d;\n}\n\n.textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #23272a;\n  color: white;\n  height: 200px;\n  resize: none;\n  box-sizing: border-box;\n  scrollbar-color: #23272a #181a1b;\n  scrollbar-width: thin;\n}\n\n.buttonGroup {\n  display: flex;\n  justify-content: space-between;\n  margin-top: auto;\n  padding-top: 20px;\n}\n\n.button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.primaryButton {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  background-color: #007BFF;\n  color: white;\n}\n\n.primaryButton:hover {\n  background-color: #0056b3;\n}\n\n.secondaryButton {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  background-color: #6c757d;\n  color: white;\n}\n\n/* Calendar icon and textarea scrollbar styles */\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: invert(50%) sepia(6%) saturate(0%) hue-rotate(180deg) brightness(90%) contrast(90%);\n}\ninput[type=\"date\"]::placeholder {\n  color: #6c757d;\n}\ntextarea::-webkit-scrollbar {\n  width: 8px;\n  background: #181a1b;\n}\ntextarea::-webkit-scrollbar-thumb {\n  background: #23272a;\n  border-radius: 4px;\n}\ntextarea::-webkit-scrollbar-corner {\n  background: #181a1b;\n}\n\n.darkDatePicker {\n  background: #23272a !important;\n  color: #fff !important;\n  border: 1px solid #444 !important;\n}\n\n.darkCalendar {\n  background: #23272a !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n  border: 1px solid #444 !important;\n}\n\n.darkCalendar .react-datepicker__day--selected,\n.darkCalendar .react-datepicker__day--keyboard-selected {\n  background: #007BFF !important;\n  color: #fff !important;\n}\n\n.darkCalendar .react-datepicker__header {\n  background: #181a1b !important;\n  border-bottom: 1px solid #444 !important;\n}\n\n.darkCalendar .react-datepicker__current-month,\n.darkCalendar .react-datepicker__day-name {\n  color: #fff !important;\n}\n\n.darkCalendar .react-datepicker__day {\n  color: #fff !important;\n}\n\n.darkCalendar .react-datepicker__day--disabled {\n  color: #666 !important;\n}\n\n.darkCalendar .react-datepicker__triangle {\n  display: none;\n}\n\n.stepsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px 10px; /* Increased top/bottom padding for better spacing */\n  border: 1px solid #444;\n  border-radius: 8px;\n  background-color: #1e1e1e;\n  box-sizing: border-box;\n  height: 100%;\n  max-height: 680px; /* Increased height to better utilize the 750px modal height */\n  overflow-y: auto; /* Enable vertical scrolling */\n}\n\n.stepsContainer h3 {\n  margin: 0 0 10px 0; /* Consistent spacing for h3 elements */\n}\n\n.stepsTableWrapper {\n  flex: 1;\n  overflow-y: auto; /* Make the table scrollable */\n}\n\n.stepsTable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 5px;\n}\n\n/* Hide column headers */\n.stepsTable th {\n  display: none;\n}\n\n.stepsTable td {\n  border: 1px solid #444;\n  padding: 8px;\n  text-align: left;\n  color: white;\n}\n\n.stepsTable tr:nth-child(even) {\n  background-color: #2b2d30;\n}\n\n.stepsTable tr:hover {\n  background-color: #3a3d42;\n}\n\n.deleteButton {\n  background: none;\n  border: none;\n  color: #ff4d4d;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.stepsInput {\n  width: 100%; /* Match the width of the table */\n  min-height: 34px; /* Ensure a single-line input field */\n  padding: 8px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #23272a;\n  color: white;\n  box-sizing: border-box; /* Ensure padding doesn't affect width */\n}\n\n/* === Listen-Items (Steps + Todos) mit Hover-Actions === */\n\n.itemCount {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 8px;\n  background-color: #2b2d30;\n  color: #aaa;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 500;\n  vertical-align: middle;\n}\n\n.itemList {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.itemEmpty {\n  color: #777;\n  font-size: 13px;\n  font-style: italic;\n  margin: 6px 2px;\n}\n\n.itemRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 7px 9px;\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 5px;\n  transition: background-color 0.15s ease;\n}\n\n/* Hover: nur subtiler Hintergrund-Lift, kein Layout-Shift, keine Icons */\n.itemRow:hover {\n  background-color: rgba(255, 255, 255, 0.07);\n}\n\n/* Aktive (ausgewaehlte/editierte) Row: deutlichere Hintergrung + Rahmen */\n.itemRow:focus-within {\n  background-color: rgba(255, 255, 255, 0.09);\n  border-color: rgba(255, 255, 255, 0.22);\n}\n\n.itemMain {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.itemText {\n  color: #e8e8e8;\n  font-size: 13.5px;\n  line-height: 1.4;\n  word-break: break-word;\n  white-space: pre-wrap;\n  cursor: text;\n}\n\n.itemDate {\n  font-size: 10.5px;\n  color: #777;\n  font-style: italic;\n}\n\n.itemEditTextarea {\n  width: 100%;\n  min-height: 1.4em;\n  background-color: #23272a;\n  border: 1px solid #4a9eff;\n  border-radius: 4px;\n  color: #e8e8e8;\n  padding: 1px 2px;\n  margin: -1px -2px;\n  font-size: 13.5px;\n  font-family: inherit;\n  line-height: 1.4;\n  outline: none;\n  resize: none;\n  overflow: hidden;\n  box-sizing: content-box;\n  /* lange Texte umbrechen wie der statische Text */\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.itemActions {\n  display: none;\n  align-items: center;\n  gap: 1px;\n  flex-shrink: 0;\n}\n\n/* Icons NUR beim Klick (Edit-Modus = Textarea hat Focus). Beim Hover: keine Icons, kein Layout-Shift. */\n.itemRow:focus-within .itemActions {\n  display: flex;\n}\n\n.itemActionBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 1;\n  color: #999;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.itemActionBtn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.itemActionDanger:hover {\n  color: #ff4d4d;\n}\n\n/* Mobile Modal Styles */\n@media (max-width: 768px) {\n  .modal {\n    padding: 0 !important;\n    align-items: flex-start !important;\n  }\n\n  .mobileModalContent {\n    width: 100vw !important;\n    height: 100vh !important;\n    background-color: #181a1b !important;\n    color: white !important;\n    border-radius: 0 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n  }\n\n  .mobileHeader {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 15px 20px !important;\n    background-color: rgba(24, 26, 27, 0.95) !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n    z-index: 10 !important;\n  }\n\n  .closeButton {\n    background: none !important;\n    border: none !important;\n    color: white !important;\n    font-size: 24px !important;\n    cursor: pointer !important;\n    width: 40px !important;\n    height: 40px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    border-radius: 50% !important;\n    transition: all 0.2s !important;\n  }\n\n  .closeButton:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n  }\n\n  .mobileTitle {\n    font-size: 18px !important;\n    margin: 0 !important;\n    text-align: center !important;\n    flex: 1 !important;\n  }\n\n  .saveButton {\n    background-color: #007BFF !important;\n    color: white !important;\n    border: none !important;\n    padding: 8px 16px !important;\n    border-radius: 6px !important;\n    cursor: pointer !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    transition: all 0.2s !important;\n  }\n\n  .saveButton:hover {\n    background-color: #0056b3 !important;\n  }\n\n  .pageIndicators {\n    display: flex !important;\n    justify-content: center !important;\n    gap: 0 !important;\n    padding: 10px 0 !important;\n    background-color: rgba(24, 26, 27, 0.95) !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n  }\n\n  .pageIndicator {\n    flex: 1 !important;\n    padding: 12px 0 !important;\n    background: none !important;\n    border: none !important;\n    color: rgba(255, 255, 255, 0.6) !important;\n    font-size: 14px !important;\n    cursor: pointer !important;\n    transition: all 0.3s !important;\n    border-bottom: 2px solid transparent !important;\n  }\n\n  .pageIndicator.active {\n    color: #007BFF !important;\n    border-bottom-color: #007BFF !important;\n  }\n\n  .mobilePages {\n    display: flex !important;\n    flex: 1 !important;\n    transition: transform 0.3s ease !important;\n    overflow: hidden !important;\n  }\n\n  .mobilePage {\n    width: 100vw !important;\n    flex-shrink: 0 !important;\n    padding: 20px !important;\n    overflow-y: auto !important;\n    box-sizing: border-box !important;\n    min-height: 100% !important;\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  .mobileForm {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 15px !important;\n    flex: 1 !important;\n    min-height: 100% !important;\n  }\n\n  .mobileFormGroup {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 8px !important;\n  }\n\n  .mobileLabel {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n    color: white !important;\n  }\n\n  .mobileInput, .mobileSelect {\n    padding: 12px !important;\n    border: 1px solid #444 !important;\n    border-radius: 6px !important;\n    font-size: 16px !important;\n    background-color: #23272a !important;\n    color: white !important;\n    box-sizing: border-box !important;\n  }\n\n  .mobileTextarea {\n    padding: 12px !important;\n    border: 1px solid #444 !important;\n    border-radius: 6px !important;\n    font-size: 16px !important;\n    background-color: #23272a !important;\n    color: white !important;\n    min-height: 120px !important;\n    resize: vertical !important;\n    box-sizing: border-box !important;\n  }\n\n  .mobileDeleteButton {\n    background-color: #dc3545 !important;\n    color: white !important;\n    border: none !important;\n    padding: 12px 20px !important;\n    border-radius: 6px !important;\n    cursor: pointer !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    transition: all 0.2s !important;\n    margin-top: 10px !important;\n  }\n\n  .mobileDeleteButton:hover {\n    background-color: #c82333 !important;\n  }\n\n  .mobilePageContent {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 15px !important;\n    flex: 1 !important;\n    min-height: 100% !important;\n  }\n\n  .mobilePageTitle {\n    font-size: 20px !important;\n    font-weight: 600 !important;\n    margin: 0 0 10px 0 !important;\n    color: white !important;\n  }\n\n  .mobileList {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 10px !important;\n  }\n\n  .mobileListItem {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    padding: 12px !important;\n    background-color: rgba(255, 255, 255, 0.05) !important;\n    border: 1px solid rgba(255, 255, 255, 0.1) !important;\n    border-radius: 6px !important;\n    gap: 10px !important;\n  }\n\n  .mobileListText {\n    flex: 1 !important;\n    color: white !important;\n    font-size: 14px !important;\n  }\n\n  .mobileListActions {\n    display: flex !important;\n    gap: 8px !important;\n  }\n\n  .mobileDoneButton {\n    background-color: #28a745 !important;\n    color: white !important;\n    border: none !important;\n    padding: 6px 12px !important;\n    border-radius: 4px !important;\n    cursor: pointer !important;\n    font-size: 12px !important;\n    font-weight: 500 !important;\n    transition: all 0.2s !important;\n  }\n\n  .mobileDoneButton:hover {\n    background-color: #218838 !important;\n  }\n\n  .mobileDeleteItemButton {\n    background-color: #dc3545 !important;\n    color: white !important;\n    border: none !important;\n    padding: 6px 10px !important;\n    border-radius: 4px !important;\n    cursor: pointer !important;\n    font-size: 12px !important;\n    transition: all 0.2s !important;\n  }\n\n  .mobileDeleteItemButton:hover {\n    background-color: #c82333 !important;\n  }\n\n  .mobileFooter {\n    display: flex !important;\n    justify-content: center !important;\n    padding: 20px !important;\n    background-color: rgba(24, 26, 27, 0.95) !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;\n  }\n\n  .mobileSaveButton {\n    background-color: #007bff !important;\n    color: white !important;\n    border: none !important;\n    padding: 12px 20px !important;\n    border-radius: 6px !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    cursor: pointer !important;\n    width: 100% !important;\n    max-width: 300px !important;\n  }\n\n  .mobileSaveButton:hover {\n    background-color: #0056b3 !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `AddTicketModal_modal__UrdUk`,
	"fadeIn": `AddTicketModal_fadeIn__PoGNS`,
	"modalContent": `AddTicketModal_modalContent__RseiN`,
	"modalContentFadeIn": `AddTicketModal_modalContentFadeIn__gTEMo`,
	"closing": `AddTicketModal_closing__A8Ga2`,
	"fadeOut": `AddTicketModal_fadeOut__WcvK9`,
	"modalContentFadeOut": `AddTicketModal_modalContentFadeOut__OK3wr`,
	"formGroup": `AddTicketModal_formGroup__U-vaS`,
	"label": `AddTicketModal_label__0AAl2`,
	"input": `AddTicketModal_input__SfpHK`,
	"select": `AddTicketModal_select__OiWL1`,
	"textarea": `AddTicketModal_textarea__DYxuR`,
	"buttonGroup": `AddTicketModal_buttonGroup__5LKrk`,
	"button": `AddTicketModal_button__s2a3Z`,
	"primaryButton": `AddTicketModal_primaryButton__RkVvc`,
	"secondaryButton": `AddTicketModal_secondaryButton__HW4xw`,
	"darkDatePicker": `AddTicketModal_darkDatePicker__RqAgk`,
	"darkCalendar": `AddTicketModal_darkCalendar__c4YaZ`,
	"react-datepicker__day--selected": `AddTicketModal_react-datepicker__day--selected__ric-l`,
	"react-datepicker__day--keyboard-selected": `AddTicketModal_react-datepicker__day--keyboard-selected__bq2Ct`,
	"react-datepicker__header": `AddTicketModal_react-datepicker__header__3LwC+`,
	"react-datepicker__current-month": `AddTicketModal_react-datepicker__current-month__LJdxs`,
	"react-datepicker__day-name": `AddTicketModal_react-datepicker__day-name__HXha2`,
	"react-datepicker__day": `AddTicketModal_react-datepicker__day__t6o+f`,
	"react-datepicker__day--disabled": `AddTicketModal_react-datepicker__day--disabled__uHYLw`,
	"react-datepicker__triangle": `AddTicketModal_react-datepicker__triangle__HgUjb`,
	"stepsContainer": `AddTicketModal_stepsContainer__tkQ0T`,
	"stepsTableWrapper": `AddTicketModal_stepsTableWrapper__FUl5h`,
	"stepsTable": `AddTicketModal_stepsTable__Qa7WU`,
	"deleteButton": `AddTicketModal_deleteButton__qQCqy`,
	"stepsInput": `AddTicketModal_stepsInput__9emB2`,
	"itemCount": `AddTicketModal_itemCount__ULbNG`,
	"itemList": `AddTicketModal_itemList__erZiL`,
	"itemEmpty": `AddTicketModal_itemEmpty__LDG3Q`,
	"itemRow": `AddTicketModal_itemRow__9+dI1`,
	"itemMain": `AddTicketModal_itemMain__Bqa0W`,
	"itemText": `AddTicketModal_itemText__slbFF`,
	"itemDate": `AddTicketModal_itemDate__lHg4J`,
	"itemEditTextarea": `AddTicketModal_itemEditTextarea__Bdxvb`,
	"itemActions": `AddTicketModal_itemActions__MXxyA`,
	"itemActionBtn": `AddTicketModal_itemActionBtn__AIGHj`,
	"itemActionDanger": `AddTicketModal_itemActionDanger__1BM8Z`,
	"mobileModalContent": `AddTicketModal_mobileModalContent__qLyfH`,
	"mobileHeader": `AddTicketModal_mobileHeader__JjHCG`,
	"closeButton": `AddTicketModal_closeButton__wjLIA`,
	"mobileTitle": `AddTicketModal_mobileTitle__oP9Ue`,
	"saveButton": `AddTicketModal_saveButton__HVADC`,
	"pageIndicators": `AddTicketModal_pageIndicators__w3iuA`,
	"pageIndicator": `AddTicketModal_pageIndicator__H2IaO`,
	"active": `AddTicketModal_active__laEJt`,
	"mobilePages": `AddTicketModal_mobilePages__HmTfm`,
	"mobilePage": `AddTicketModal_mobilePage__yWZua`,
	"mobileForm": `AddTicketModal_mobileForm__ETa-5`,
	"mobileFormGroup": `AddTicketModal_mobileFormGroup__x+LWc`,
	"mobileLabel": `AddTicketModal_mobileLabel__MHguU`,
	"mobileInput": `AddTicketModal_mobileInput__B1WCN`,
	"mobileSelect": `AddTicketModal_mobileSelect__zuo0E`,
	"mobileTextarea": `AddTicketModal_mobileTextarea__6OOki`,
	"mobileDeleteButton": `AddTicketModal_mobileDeleteButton__mXqte`,
	"mobilePageContent": `AddTicketModal_mobilePageContent__uxCz+`,
	"mobilePageTitle": `AddTicketModal_mobilePageTitle__NIxNB`,
	"mobileList": `AddTicketModal_mobileList__Epy01`,
	"mobileListItem": `AddTicketModal_mobileListItem__O+gVp`,
	"mobileListText": `AddTicketModal_mobileListText__rwfox`,
	"mobileListActions": `AddTicketModal_mobileListActions__gfj1Q`,
	"mobileDoneButton": `AddTicketModal_mobileDoneButton__kqQp6`,
	"mobileDeleteItemButton": `AddTicketModal_mobileDeleteItemButton__wlq8G`,
	"mobileFooter": `AddTicketModal_mobileFooter__9QLFo`,
	"mobileSaveButton": `AddTicketModal_mobileSaveButton__IizSX`,
	"modalFadeIn": `AddTicketModal_modalFadeIn__ERpuN`,
	"modalContentZoom": `AddTicketModal_modalContentZoom__d353l`,
	"modalFadeOut": `AddTicketModal_modalFadeOut__vWzdU`,
	"modalContentZoomOut": `AddTicketModal_modalContentZoomOut__cPV+K`,
	"fadeInOut": `AddTicketModal_fadeInOut__2EMeF`
};
export default ___CSS_LOADER_EXPORT___;
